module.exports = __webpack_public_path__ + "fonts/Inter-Bold-slnt=0.91e5aee8.ttf";